export default __webpack_public_path__ + "static/media/icon_5_0.5d18d1ac.svg";